import { Input } from "./beui/Input";
import { Button } from "./beui/Button";
import { Trash2 } from "lucide-react";

type MilestoneRow = { label: string; amount: string };

// Quotation and item negotiation share row presentation; each parent owns its
// limits, source-specific centavo precision, required/default stages, allocation
// validation and submission. Other callers retain whole-peso controls by default.
export function MilestoneRows({ rows, onChange, maxAmount, minRows = 0, allowCentavos = false, placeholder }: {
  rows: MilestoneRow[];
  onChange: (rows: MilestoneRow[]) => void;
  maxAmount: number;
  minRows?: number;
  allowCentavos?: boolean;
  placeholder: (index: number) => string;
}) {
  function update(index: number, values: Partial<MilestoneRow>) {
    onChange(rows.map((row, position) => position === index ? { ...row, ...values } : row));
  }

  return <div className="space-y-2">
    {rows.map((row, index) => <div key={index} className="grid grid-cols-[minmax(0,1fr)_2.5rem] gap-2 min-[420px]:grid-cols-[minmax(0,1fr)_7rem_2.5rem]">
      <Input required maxLength={120} className="col-span-2 min-w-0 min-[420px]:col-span-1" classNames={{ field: "h-11 bg-white", input: "text-sm font-normal" }} aria-label={`Milestone ${index + 1} deliverable`} placeholder={placeholder(index)} value={row.label} onChange={value => update(index, { label: value })} />
      <Input required type="number" inputMode={allowCentavos ? "decimal" : "numeric"} min={allowCentavos ? 0.01 : 1} max={maxAmount} step={allowCentavos ? 0.01 : 1} className="min-w-0" classNames={{ field: "h-11 bg-white", input: "text-sm font-normal" }} aria-label={`Milestone ${index + 1} amount (PHP)`} placeholder="Amount (₱)" value={row.amount} onChange={value => update(index, { amount: value })} />
      <Button variant="ghost" size="icon" type="button" disabled={rows.length <= minRows} aria-label={`Remove milestone ${index + 1}`} className="grid h-11 w-10 place-items-center rounded-lg text-mut hover:bg-navy-50 hover:text-brand-red focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy-500 disabled:opacity-30" onClick={() => onChange(rows.filter((_, position) => position !== index))}><Trash2 aria-hidden="true" className="h-4 w-4" /></Button>
    </div>)}
  </div>;
}
